<template>
  <vs-popup class=""
            id="popup"
            title="REPLICATE FORMULATION"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateFormulation)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="createStaffForm.name"   name="name" class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="legal_name" name="legal_name" rules="required" v-slot="{ errors }">
                <small class="label">Legal name</small>
                <vs-input v-model="createStaffForm.legal_name"   name="legal_name" class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" >
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <small class="label">Formulation type</small>
                <v-select name="formulation_type"  v-model="createStaffForm.formulation_type" :options="['powder', 'liquid', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col  md:w-full w-full md:mb-0">
              <ValidationProvider vid="batch_weight" name="batch_weight" rules="required|" v-slot="{ errors }">
                <small class="label">Batch weight (Kg)</small>
                <vs-input type="number" v-model="createStaffForm.batch_weight" class="w-full"  name="batch_weight" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="createStaffForm.description" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const StaffRepository = RepositoryFactory.get('staff')
  const DepartmentsRepository = RepositoryFactory.get('departments')
  const RolesRepository = RepositoryFactory.get('roles');
  const FormulationsRepository = RepositoryFactory.get('formulations')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      roles: [],
      selectedStaff: {},
      departments: [],
      selected: [],
      updateStaffSelected: [],
      createStaffForm: {
        batch_weight: '100'
      },
      formulation_id: null
    }
  }

export default {
  name: 'ReplicaFormulationPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.formulation_id = id
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateFormulation () {
      const vue = this;
      this.$vs.loading()
       try {
         const data = (await FormulationsRepository.createReplicate(this.createStaffForm, this.formulation_id)).data.data
         this.showSuccessMessage('Formulation replicated successfully')
         // this.createStaffForm = {}
         // await vue.$parent.refreshData()
         this.open = false;
         await this.$router.push({path: `/pages/formulations/${data.id}`})
         location.reload()
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },

    async getStaff(id) {
      const { data } = await StaffRepository.getStaff(id)
      this.selectedStaff = data.data
    },
    onClickReset() {
      this.createStaffForm = {}
      this.selected= []
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
